<template>
  <div>
    <div class="ul-top box-sizing">
      <div class="ul-item">
        <span class="lab">时间：</span>
        <span class="opt">
                    <el-date-picker
                        v-model="timeGroup"
                        type="daterange"
                        unlink-panels
                        value-format="timestamp"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :editable="false"
                        :picker-options="pickerOptions"
                        :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </span>
        <span class="lab">关键词：</span>
        <span class="opt"><el-input class="inp" placeholder="请输入网址或备注" v-model="keyword" clearable></el-input></span>


        <span class="btn"><el-button type="primary" @click="getList">搜索</el-button></span>
      </div>


      <div class="btn-features">

        <el-popconfirm title="确定删除选中的网址吗？" @confirm="delLabel" style="margin-left: 10px">
          <el-button type="danger" slot="reference">删除选中</el-button>
        </el-popconfirm>



      </div>
    </div>

    <div class="ul-mid box-sizing">
<!--        <div class="mt10">快速选择：-->
<!--            <span class="blue "  @click="wx_status='';getList()">全部</span>-->
<!--            <span class="blue ml20" @click="wx_status=1;getList()">禁止访问</span>-->
<!--          <span class="blue ml20" @click="wx_status=2;getList()">提示访问</span>-->
<!--            <span class="blue ml20"  @click="wx_status=0;getList()">正常</span>-->

<!--        </div>-->
      <el-table v-loading="isLoading" :data="tableData"  empty-text="暂无数据" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="42"></el-table-column>
        <el-table-column prop="url" label="网址">
          <template slot-scope="scope">
             <a :href="scope.row.url"  style="color:#000;" target="_blank">{{scope.row.url}}</a>
          </template>

        </el-table-column>
        <el-table-column prop="wx_status" label="微信状态">
          <template slot-scope="scope">
            <font v-if="scope.row.wx_status==1" color="red">禁止访问</font>
            <font v-if="scope.row.wx_status==2" color="blue">提示访问</font>
            <font v-if="scope.row.wx_status==0" color="#006400">正常</font>
          </template>

        </el-table-column>
        <el-table-column prop="create_time" label="添加时间"></el-table-column>
        <el-table-column label="备注" class-name="text-align">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="点击修改备注" placement="top">
              <div class="link-mark" @click="editMark(scope.row)">{{scope.row.mark}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="delLabel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagebar" v-show="total>5">
        <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :pageSize="100" @current-change="handleCurrentPage"></el-pagination>
      </div>
    </div>

    <el-dialog title="设置备注" :visible.sync="addLabelDialog" center width="400px">
            <span>
                <el-form :model="labelData" :rules="labelRules" ref="labelForm">
                    <el-form-item label="网址" prop="name">
                        <el-input v-model="labelData.url"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="mark">
                        <el-input v-model="labelData.mark"></el-input>
                    </el-form-item>
                </el-form>
            </span>
      <span slot="footer">
                <el-button @click="addLabelDialog=false">取消</el-button>
                <el-button type="primary" :loading="addLabelLoad" @click="addLabel">确定</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "UserLabel",
  data() {
    return {
      total: 0,
      keyword: "",
      selUrlID: "",
      timeGroup: [],
      tableData: [],
        statData:{},
      isLoading: false,
      currentPage: 1,
      urlmark:'',
      addLabelLoad: false,
      addLabelDialog: false,
      add2LabelLoad:false,
      add2LabelDialog: false,
      markDialog: false,
        wx_status:0,
      urls:'',
      labelData: {
        id: 0,
        url: "",
        mark: "",
      },
      labelRules:{
        url: [
          { required: true, message: '请输入网址', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在 1 到 8 个字符', trigger: 'blur' }
        ],
        mark: [
          { min: 1, max: 25, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  mounted() {
    setTimeout(this.getList,200);
  },
  methods: {

    async saveMark() {
      if (!this.selDomainID) {
        this.$message.error('数据出错！请刷新后重试');
        return;
      }
      this.isLoading2 = true;
      const postData = {
        id: this.selDomainID,
        mark:  this.urlmark,
      };
      const {ret} = await this.$api.exclusive.saveMark(postData);
      if (ret === 1000){
        this.isLoading2 = false;
        this.markDialog = false;
        this.$message.success('保存成功！');
        this.getList();
      }
    },
    async getList() {
      this.isLoading = true;
      let start = 0;
      let end = 0;
      if (this.timeGroup === null) this.timeGroup = [];
      if (this.timeGroup.length === 2){
        start = this.timeGroup[0];
        end = this.timeGroup[1];
      }
      const getData = {
        start: Number(start/1000),
        end: Number(end/1000),
        keyword: this.keyword,
        p: this.currentPage,
          wx_status:this.wx_status,
      };
      const {ret,data} = await this.$api.exclusive.getLongurlList(getData);
      this.isLoading = false;
      if (ret === 1000){
        this.total = Number(data['total']);
        this.tableData = data['list'];
          this.statData = data['stat'];
      }
    },

    delLabel(id) {
      let ids = "";
      if (id){
        ids = id;
      }else {
        ids = this.selUrlID;
      }
      if (ids === ""){
        this.$message.error("请选择要删除的链接！");
        return;
      }
      this.$confirm('确定删除， 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {ret} = await this.$api.exclusive.delLongurl({ids:ids});
        if (ret === 1000){
          this.getList();
          this.$message.success("删除成功！");
        }
      });
    },
    editMark(item) {
      this.markDialog = true;
      this.selDomainID = item.id;
      this.urlmark = item.mark;
    },
    editLabel(item){
      this.labelData.id = item.id;
      this.labelData.url = item.url;
      this.labelData.mark = item.mark;
      this.addLabelDialog = true;
    },
    showAddLabelDialog() {
      this.labelData.id = 0;
      this.labelData.url = "";
      this.labelData.mark = "";
      this.addLabelDialog = true;
    },
    showAdd2LabelDialog() {
      this.labelData.id = 0;
      this.labelData.url = "";
      this.add2LabelDialog = true;
    },
    async daoru_yuan() {
      const $this = this;
      this.$confirm('将短网址的原链接直接导入到监控列表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {ret} = await this.$api.monitorUrl.import();
        if (ret === 1000){
          $this.getList();
          $this.$message.success("导入成功！");
        }
      });
    },
    handleCurrentPage(val) {
      this.currentPage = val;
      this.getList();
    },
    tongzhiss() {
      this.$router.push({ path:'/tabs/userInfo'  })
    },
    handleSelectionChange(val) {
      if (val.length === 0){
        return;
      }
      let ids = "";
      for (const item of val){
        ids += item.id+",";
      }
      ids = ids.substr(0,ids.length-1);
      this.selUrlID = ids;
    }
  }
}
</script>

<style scoped>
.ul-top{
  width: 100%;
  height: auto;
  padding: 20px;
}
.ul-top .ul-item{
  width: 100%;
  height: 40px;
  color: #666666;
  margin-bottom: 10px;
}
.ul-top .ul-item .lab{
  display: inline-block;
  width: 70px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: right;
  margin-right: 10px;
  vertical-align: top;
}
.ul-top .ul-item .opt{
  display: inline-block;
  width: 350px;
  height: 40px;
  vertical-align: top;
}
.ul-top .ul-item .btn{
  display: inline-block;
  width: 70px;
  height: 40px;
  margin-left: 10px;
  vertical-align: top;
}
.ul-top .ul-item .inp{
  width: 350px;
}
.ul-top .btn-features{
  width: 100%;
  height: 40px;
  margin-top: 30px;
}
.ul-mid{
  width: 100%;
  padding: 0 20px;
}
.ul-mid .pagebar{
  width: 100%;
  height: 52px;
  margin-top: 20px;
}
</style>
